import type { EnvSection } from '@cli-types/core-engine/env.js'

export function flattenEnvKeys(definition: { envSections: EnvSection[] }): string[] {
  return definition.envSections.flatMap((section) => section.vars.map((entry) => entry.key))
}
